import moment from 'moment';

let locale = `${Phoenix.laravelLanguage.toLowerCase()}-${Phoenix.currentCountry.toLowerCase()}`;
if (Phoenix.laravelLanguage.toLowerCase() === 'en' && Phoenix.currentCountry.toLowerCase() !== 'us') {
  locale = 'en-gb';
}

moment.locale(locale);

export default moment;
